import { HistoryEntry } from ".";
import { PermissionGroup } from "./permissions";
import { IPricingWorkload } from "./pricingWorkload";

export type CreateAdmin = {
  emailId: string;
  firstName: string;
  lastName: string;
  password: string;
  role: string;
  countryCode: string;
  phoneNumber: string;
  profilePicUrl: string;
  emailNotificationActive: boolean;
  permissionGroupIds: string[];
};

export interface AdminUsers {
  _id: string;
  emailId: string;
  firebaseRefId: string;
  firstName: string;
  lastName: string;
  role: string;
  history: HistoryEntry[];
  permissions: string[];
  accountStatus: string;
  phoneNumber: string;
  countryCode: string;
  profilePicUrl: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  adminId: string;
  status: ACCOUNT_STATUS;
  permissionGroups?: PermissionGroup[];
  demoMode?: boolean;
  pricingWorkload?: IPricingWorkload;
}

export interface AdminUser {
  _id: string;
  emailId: string;
  firebaseRefId: string;
  firstName: string;
  lastName: string;
  role: string;
  history: HistoryEntry[];
  permissions: string[];
  accountStatus: string;
  phoneNumber: string;
  countryCode: string;
  profilePicUrl: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  status: ACCOUNT_STATUS;
  assignedBrands: BrandAdminPermisson[];
  emailNotificationActive: boolean;
  permissionGroups?: PermissionGroup[];
  permissionGroupIds: string[];
  demoMode?: boolean;
}
type PermissionEntry = {
  createdOn: string;
  updatedAt: string;
  userId: string;
  userType: string;
  permissions: string[];
  user: string;
  userModelName: string;
};

export enum ACCOUNT_STATUS {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export interface BrandAdminPermisson {
  _id: string;
  name: string;
  logoUrl: string;
  history: HistoryEntry[];
  companyName: string;
  permission: PermissionEntry[];
  createdAt: string;
  updatedAt: string;
  __v: number;
  brandId: string;
  userPermissions: string[];
}

export interface IPagination {
  totalCount: number;
  totalPages: number;
  currentPage: number;
  limit: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}
export interface GetAdmins {
  data: AdminUsers[];
  pagination: IPagination;
  accountStatusCount: { [key: string]: number };
}
export interface PermissionsConst {
  admin: string[];
  brand: string[];
}

export interface UserDetailsResponse {
  userEntity: {
    id: string;
    firstName: string;
    lastName: string;
    emailId: string;
    phoneNumber: string;
    countryCode: string;
    profilePicUrl: string;
    firebaseUserId: string;
    permissions: string[];
    type: string;
  };
  isMfaRequired: boolean;
}
